import Image from 'next/image';
import React, { useEffect } from 'react';
import { usePayment } from '@/features/subscription/hooks/usePayment';
import { Button } from '@heroui/button';
import { useAppDispatch } from '@/hooks/redux';
import { hideSide, showSide } from '@/store/slices/sideSlice';
import { usePlan } from '../../hooks/usePlan';
import { PlanTypeEnum } from '../../enum/planType';
import { useTranslations } from 'next-intl';

const PaymentSuccess = () => {
  const t = useTranslations('sides.payment_result.success');
  const { resetPaymentStatus } = usePayment();
  const { planRemainingSeats, plan } = usePlan();
  const dispatch = useAppDispatch();

  const launchTeamSide = () => {
    dispatch(
      showSide({
        sideKey: 'teamInvite',
        sideData: {
          seats: planRemainingSeats,
        },
      })
    );
  };

  const skipForNow = () => {
    dispatch(hideSide());
  };

  useEffect(() => {
    resetPaymentStatus();
    if (plan?.type !== PlanTypeEnum.MULTIPLE) {
      setTimeout(() => {
        dispatch(hideSide());
      }, 1000);
    }
  }, []);

  return (
    <div className="w-full h-dvh flex flex-col items-center justify-center">
      <div className="flex px-5 justify-center items-start">
        <div className="flex flex-col items-center w-full">
          <h2 className="text-center text-dark text-[32px] md:text-[40px] font-semibold">
            {t('title')}
          </h2>
          <Image
            src={'/images/try-7days-ok/banner.svg'}
            width={298}
            height={260}
            alt="payment success"
            className="mt-[32px]"
          />
          <p className="text-gray-medium text-[17px] md:text-lg mt-[32px] text-center">
            {t('message')}
          </p>

          <p className="text-gray-medium text-[17px] md:text-lg mt-2 text-center">
            {t('cancel_info')}
          </p>

          {plan?.type === PlanTypeEnum.MULTIPLE && (
            <div className="flex flex-col items-center mt-6">
              <Button
                onClick={launchTeamSide}
                variant="solid"
                color="primary"
                className="!border-1 text-white h-[48px] !rounded-extra text-[17px] font-medium w-[180px]"
              >
                {t('team.add_members')}
              </Button>

              <button
                onClick={skipForNow}
                className="text-gray-medium text-[12px] md:text-sm mt-6 text-center hover:text-gray-dark transition-colors cursor-pointer"
              >
                {t('team.skip')}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;
